import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorToolsDiscovery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#TwoColorTools_Discovery_svg__a)">
      <path
        fill="#F7A600"
        d="M12 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1Zm0 20a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm8-8a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM1 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H1ZM9 12a3 3 0 1 1 6 0 3 3 0 1 1-6 0Z"
      />
      <path
        fill={getTheme(props["data-theme"])}
        d="M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
      />
    </g>
    <defs>
      <clipPath id="TwoColorTools_Discovery_svg__a">
        <rect width={24} height={24} fill="#fff" rx={12} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwoColorToolsDiscovery;
